module.exports = __webpack_public_path__ + "media/images/logoip_blanc-bc96dc2d1c554b75371384ee562a6005.png";